import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for  Attention Index page */
export default class GlobalAttentionOnBoarding extends React.Component {
  static propTypes = {
    run: PropTypes.bool.isRequired,
    setScroll: PropTypes.func.isRequired
  }

  static defaultProps = {
    includeTlm: true
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
        callback={evt => {
          if (evt.index === 2)
            this.props.setScroll()
          }
        }
        />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Attention Index dashboard!<br /><br />This Attention Index shows the top 200 titles that are most engaged with by audiences across social media platforms for the week.<br /></p>),
        placement: 'center',
        disableBeacon: true,
        target: 'body'
      },
      {
        ...common,
        content: (<p>Select from “Top Content”, “Anticipation”, and ”Trending” from the dropdown menu.<br /><br />Use the date selector to see the data from previous weeks.</p>),
        target: '#headerMenu'
      }
    ]

    return steps
  }
}
